// src/components/BrandLogo.js
import React from 'react';
import '../styles/BrandLogo.css';

export default function BrandLogo({ size = 'lg', showLabs = false }) {
  return (
    <span className={`brand-logo brand-${size}`} role="img" aria-label="getSurvey logo">
      <span className="bl base">get</span>
      <span className="bl accent">Survey</span>
      {showLabs && (
        <span className="brand-badge" aria-label="Survey Labs">Survey Labs</span>
      )}
    </span>
  );
}
